// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class ProfileRef implements flatbuffers.IUnpackableObject<ProfileRefT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ProfileRef {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsProfileRef(bb:flatbuffers.ByteBuffer, obj?:ProfileRef):ProfileRef {
  return (obj || new ProfileRef()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsProfileRef(bb:flatbuffers.ByteBuffer, obj?:ProfileRef):ProfileRef {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ProfileRef()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

id():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('-1');
}

dname():string|null
dname(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dname(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

handle():string|null
handle(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
handle(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startProfileRef(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addId(builder:flatbuffers.Builder, id:bigint) {
  builder.addFieldInt64(0, id, BigInt('-1'));
}

static addDname(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dnameOffset, 0);
}

static addHandle(builder:flatbuffers.Builder, handleOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, handleOffset, 0);
}

static endProfileRef(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createProfileRef(builder:flatbuffers.Builder, id:bigint, dnameOffset:flatbuffers.Offset, handleOffset:flatbuffers.Offset):flatbuffers.Offset {
  ProfileRef.startProfileRef(builder);
  ProfileRef.addId(builder, id);
  ProfileRef.addDname(builder, dnameOffset);
  ProfileRef.addHandle(builder, handleOffset);
  return ProfileRef.endProfileRef(builder);
}

unpack(): ProfileRefT {
  return new ProfileRefT(
    this.id(),
    this.dname(),
    this.handle()
  );
}


unpackTo(_o: ProfileRefT): void {
  _o.id = this.id();
  _o.dname = this.dname();
  _o.handle = this.handle();
}
}

export class ProfileRefT implements flatbuffers.IGeneratedObject {
constructor(
  public id: bigint = BigInt('-1'),
  public dname: string|Uint8Array|null = null,
  public handle: string|Uint8Array|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const dname = (this.dname !== null ? builder.createString(this.dname!) : 0);
  const handle = (this.handle !== null ? builder.createString(this.handle!) : 0);

  return ProfileRef.createProfileRef(builder,
    this.id,
    dname,
    handle
  );
}
}
